(function (angular) {
    // Label display not correct if input autofill (chrome)
    angular.module('shared').directive('autofill', function () {
        return {
            restrict: 'A',
            link: function (scope, $el) {
                let input = $el[0];
                const AUTOFILLED = 'is-autofilled'
                const onAutoFillStart = (el) => {
                    let mdInputContainer = $(el).closest('md-input-container');
                    mdInputContainer.addClass('md-input-has-value');
                    el.classList.add(AUTOFILLED);
                };
                const onAutoFillCancel = (el) => {
                    let mdInputContainer = $(el).closest('md-input-container');
                    mdInputContainer.removeClass('md-input-has-value');
                    el.classList.remove(AUTOFILLED);
                }
                const onAnimationStart = (event) => {
                    let target = event.target;
                    let animationName = event.animationName;
                    switch (animationName) {
                        case 'onAutoFillStart':
                            return onAutoFillStart(target)
                        case 'onAutoFillCancel':
                            return onAutoFillCancel(target)
                    }
                }
                input.addEventListener('animationstart', onAnimationStart, false)
            }
        };
    });

}(angular));